module.exports = __webpack_public_path__ + "img/xmy.ff9e8dd3.svg";